import { dataSlidersSquare } from 'dls-icons-data'
import { createIcon } from '../common'

const IconSlidersSquare = /*#__PURE__*/createIcon(dataSlidersSquare)
export default IconSlidersSquare
